import React from 'react';
import * as LucideIcons from 'lucide-react';
import { HelpCircle } from 'lucide-react';

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
 if (name === 'LayoutDashboard') {  // 홈 아이콘(대시보드 아이콘)만 우리 로고로 변경
  return (
    <img
      src="/assets/images/ogada-logo-1770865214464.png"
      alt="OGADA"
      style={{
        width: size,
        height: size,
      }}
      className="object-contain"
    />
  );
}

const IconComponent = LucideIcons?.[name];

if (!IconComponent) {
  return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
}

return <IconComponent
  size={size}
  color={color}
  strokeWidth={strokeWidth}
  className={className}
  {...props}
/>;
}
export default Icon;